import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { TemplateEditor } from "../template-editor/template-editor";

export const CreateTemplate = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <title>{t("templates.createNew")}</title>

            <TemplateEditor isCreate={true} />
        </>
    );
};
